var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Step as MuiStep, StepIcon } from '@mui/material';
import { useContext, useState } from 'react';
import { StatusPermission } from '../../enum';
import { useTerminologyTranslation } from '../app/terminology';
import { ConfirmDialog } from '../common/confirmDialog';
import { StyledStepConnector, StyledStepLabel, StyledStepper } from '../common/stepperStyles';
import { STEP_NAME, getWorkflowSteps } from './constants';
import { WizardContext } from './context';
import { useEffectiveCapacityPermission, usePlanTypeCategory, useWizardParams } from './selectors';
var CircleStep = function (props) {
  return _jsx(StepIcon, __assign({}, props, {
    completed: false
  }));
};
var Step = function (_a) {
  var value = _a.value,
    props = __rest(_a, ["value"]);
  var capacityPermission = useEffectiveCapacityPermission();
  var stepName = STEP_NAME[value];
  var t = useTerminologyTranslation(['wizard', 'translation']).t;
  var step = useWizardParams().step;
  var planTypeCategory = usePlanTypeCategory();
  var workflowSteps = getWorkflowSteps(planTypeCategory);
  var currentStepIndex = workflowSteps.indexOf(step);
  var valueStepIndex = workflowSteps.indexOf(value);
  var _b = useContext(WizardContext),
    handleSave = _b.handleSave,
    goToStep = _b.goToStep,
    isDirty = _b.methods.formState.isDirty;
  var _c = useState(false),
    open = _c[0],
    setOpen = _c[1];
  var handleClick = function () {
    if (isDirty && currentStepIndex > valueStepIndex) {
      setOpen(true);
      return;
    }
    if (currentStepIndex > valueStepIndex) {
      handleSave('goToStep', function () {
        return goToStep(valueStepIndex);
      })();
    }
  };
  var handleConfirm = function () {
    setOpen(false);
    if (currentStepIndex > valueStepIndex) {
      handleSave('goToStep', function () {
        return goToStep(valueStepIndex);
      })();
    }
  };
  return _jsxs(_Fragment, {
    children: [_jsx(MuiStep, __assign({}, props, {
      completed: currentStepIndex > valueStepIndex && capacityPermission === StatusPermission.Edit
    }, {
      children: _jsx(StyledStepLabel, __assign({
        StepIconComponent: CircleStep,
        sx: {
          fontSize: 20
        },
        color: "inherit",
        onClick: capacityPermission === StatusPermission.Edit ? handleClick : undefined
      }, {
        children: t("".concat(stepName, ".name"), {
          defaultValue: stepName
        })
      }))
    })), isDirty && _jsx(ConfirmDialog, {
      open: open,
      onClose: function () {
        return setOpen(false);
      },
      title: t('translation:confirmation.unsavedChange'),
      message: t('translation:confirmation.confirmExit'),
      confirmButtonText: "saveContinue",
      skipSaveButtonText: "skipSave",
      onConfirm: handleConfirm,
      onSkipSaveConfirm: function () {
        return goToStep(valueStepIndex);
      }
    })]
  });
};
export var Steps = function () {
  var step = useWizardParams().step;
  var planTypeCategory = usePlanTypeCategory();
  var workflowSteps = getWorkflowSteps(planTypeCategory);
  return _jsx(StyledStepper, __assign({
    nonLinear: true,
    alternativeLabel: true,
    activeStep: workflowSteps.indexOf(step),
    connector: _jsx(StyledStepConnector, {})
  }, {
    children: workflowSteps.map(function (stepValue) {
      return _jsx(Step, {
        value: stepValue
      }, stepValue);
    })
  }));
};